import { _ROLES_BACK } from "../../utils/constants";
import { BaseBudgetInput } from "../../components/budget/BaseBudgetInput";
import TableInputSalesAgg from "../../components/budget/inputSalesAgg/TableInputSalesAgg";
import { _ROUTES } from "../../utils/_routes_constants";
import {
  AllCommunityModule,
  ModuleRegistry,
  RowApiModule,
} from "ag-grid-community";
import {
  CellSelectionModule,
  ExcelExportModule,
  RowGroupingModule,
  RowGroupingPanelModule,
} from "ag-grid-enterprise";
import { useEffect, useState } from "react";
import {
  LINKED_AGGREGATE_DATA,
  SAVE_CATEGORY_AGGREGATE,
} from "../../utils/constantsSave";
import { sendToFinancialData } from "../../components/budget/BaseBudgetSaveFunctions";

ModuleRegistry.registerModules([
  AllCommunityModule,
  ExcelExportModule,
  RowGroupingModule,
  RowGroupingPanelModule,
  CellSelectionModule,
  RowApiModule,
]);

const InputSaleAgg = () => {
  const [siteData, setSiteData] = useState([]);
  const [oldInternalVolume, setOldInternalVolume] = useState({});
  const [saveData, setSaveData] = useState([]);
  const arrayData = LINKED_AGGREGATE_DATA;
  const save_name_category = SAVE_CATEGORY_AGGREGATE;
  const [params, setParams] = useState({});

  useEffect(() => {
    if (saveData.length > 0) {
      const modifiedData = saveData
        ?.map((d) => {
          if (!d) return null;

          const payload = {
            activityName: "AGG",
            siteId: params.site,
            theme: d.sale,
            months: {},
          };

          for (let i = 1; i <= 12; i++) {
            payload.months[i] = d.months[i] || 0;
          }

          return payload;
        })
        .filter(
          (item) =>
            item !== null &&
            (item.theme === "INTERNAL TURN OVER" ||
              item.theme === "EXTERNAL TURN OVER" ||
              item.theme === "EXTERNAL VOLUMES" ||
              item.theme === "INTERNAL VOLUMES"),
        );

      sendToFinancialData(modifiedData, save_name_category, () => {
        setSaveData([]);
      });
    }
  }, [saveData]);

  return (
    <BaseBudgetInput
      title="Input Sale Aggregate"
      roles={[_ROLES_BACK._ROLE_ADMIN, _ROLES_BACK._ROLE_CTRL]}
      userRole={_ROLES_BACK._ROLE_SALES}
      enableFlag="dataEntryEnableSale"
      TableComponent={TableInputSalesAgg}
      saveData={saveData}
      setSaveData={setSaveData}
      includeBaseBudgetSave={true}
      arrayData={arrayData}
      saveNameCategory={save_name_category}
      onParamsChange={setParams}
      tableComponentProps={{
        siteData,
        oldInternalVolume,
        setOldInternalVolume,
      }}
      filters={[
        {
          key: "site",
          route: _ROUTES.SITES,
          defaultValue: "",
          label: "Site",
          queryParams: {
            active: 1,
            "activities.code": "AGG",
            "order[name]": "ASC",
            "groups[]": "select:get",
          },
          onDataLoad: (data) => {
            setSiteData(data);
          },
        },
      ]}
    />
  );
};

export default InputSaleAgg;
